/* import __COLOCATED_TEMPLATE__ from './location-selector-modal.hbs.js'; */
import Component from '@glimmer/component';
export default class LocationSelectorModal extends Component {
  get allowDisablingPrimaryButton() {
    return false;
  }
  get enableIndeterminateState() {
    return true;
  }
}